export const TRUTHY = 'TRUTHY'
export const FALSY = 'FALSY'

export const TAGS = {
  draft: {
    TRUTHY: {
      colour: '#6125F5',
      text: 'Draft'
    }
  },
  pinned: {
    TRUTHY: {
      colour: '#54ACEA',
      text: 'Pinned'
    }
  },
  published: {
    FALSY: {
      colour: '#EB5A33',
      text: 'Unpublished'
    },
    TRUTHY: {
      colour: '#8EC771',
      text: 'Published'
    }
  }
}
